module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-h-7 tw-group tw-flex tw-items-center",
    class: {
      'tw-cursor-pointer': !_vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.click()
      }
    }
  }, [_c('div', {
    staticClass: "tw-h-7 tw-w-7 tw-rounded tw-flex tw-items-center tw-justify-center tw-duration-200 tw-transition-all",
    class: {
      'group-hover:tw-bg-gray-100/50': !_vm.disabled
    }
  }, [_c('div', {
    staticClass: "tw-h-5 tw-w-5 tw-border tw-flex tw-text-white tw-items-center tw-justify-center tw-rounded-[2px] tw-duration-200 tw-transition-all",
    class: [{
        'tw-bg-teal-400 tw-border-teal-400 group-hover:tw-bg-teal-300 group-hover:tw-border-teal-300': _vm.isChecked && !_vm.disabled
      },
      {
        'tw-bg-white tw-border-neutral-200': !_vm.isChecked && !_vm.disabled
      },
      {
        'tw-bg-gray-400 tw-border-neutral-400': _vm.disabled
      }
    ]
  }, [(_vm.isChecked) ? _c('span', {
    staticClass: "fa-regular fa-check"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tw-ml-1",
    class: {
      'tw-text-white': _vm.dark, 'tw-text-gray-400': _vm.disabled
    }
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f6ab198"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/Checkbox/checkbox.vue.html
// module id = /EqK
// module chunks = 2